import axios from 'axios';

const API = axios.create({ baseURL: 'http://api.invoice.veramasa.com/api' });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const login = (data) => API.post('/auth/login', data);
export const getClients = () => API.get('/clients');
export const getClient = (id) => API.get(`/clients/${id}`);
export const addClient = (data) => API.post('/clients', data);
export const getInvoices = () => API.get('/invoices');
export const getInvoice = (id) => API.get(`/invoices/${id}`);
export const createInvoice = (data) => API.post('/invoices', data);
export const getSectorConfig = (sector) => API.get(`/invoices/config/sector/${sector}`);

export default API;
